import React from "react";
import { Layout } from "components/Layout/Layout";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";
import Grid from "@mui/material/Grid2";
import { useProjectTaskDashboardContext } from "./context";
import { ProjectTaskListForDashboard } from "./components/ProjectTaskList";
import { ProjectProductTaskListForDashboard } from "./components/ProjectProductTaskList";

export const ProjectTaskDashboardViewer = () => {
  const { currentProject } = useProjectTaskDashboardContext();

  return (
    <Layout>
      <PageTitle pageName={pageName.dashboard.project} />
      <ToolbarThinWrapper />
      <ToolbarThinWrapper />
      <Grid container spacing={1}>
        <Grid size={{ md: 6, xs: 12 }}>
          <ProjectTaskListForDashboard pageName={pageName.dashboard.project} />
        </Grid>
        {currentProject > 0 && (
          <Grid size={{ md: 6, xs: 12 }}>
            <ProjectProductTaskListForDashboard
              pageName={pageName.dashboard.projectProduct}
            />
          </Grid>
        )}
      </Grid>
    </Layout>
  );
};
